export {fetchFabricator, setActiveFeatureGroupName, updateFabricatorTransientField, getFabricatorFromState,
  authGoogleCalendar, loadAndFetchFabricator} from './fabricator';
export {changeLocation} from './location';
export {setSearchTerm} from './search';
export {fetchStones, filterStonesColor, filterStonesMaterial, normalizeStones,
  fetchStonesFilters, addMaterialsFilter, loadAndFetchStones, updateStoneSupplierStoneStoreValue, deleteStone,
  enableAllFabricatorStones }
  from './stones';
export {loadEditor, unloadEditor, updateTransientField, getItemUpdateCount, enableAllTransientStones, updateTransientFieldForCustomEditor} from './editor';
export { getCustomers, changeCustomerStatus } from './customers';
export {login, logout, setRedirectTo, getRedirectTo, requireFabricatorAdmin, toggleWarningOff} from './auth';
export {
  fetchJobs, expandJob, toggleJobTypeDropDownVisibility, showQuoteEditLayer,
  showLeadTypeDropDown, showJobStatusDropDown, changeJobStatus, loadJobLogEntries, loadJobMessageHistory,
  setFilter, jobBoardSetSearchTerm, jobBoardShowJobScheduling, jobBoardExport, uploadExclusionList, downloadExclusionList
} from '../components/JobBoard/JobBoardActions';
export { messageBox_Show, messageBoxComponent_Show, messageBoxEx_Show, loadingDialog_show, showFabricatorsPopup } from './A_Popups.js';
export { savePendingUpdates, cancelPendingUpdates } from './EditorFooter.js';
import { getApiConfig } from '../utilities';
import { getAllFabricators } from '../components/Fabricators/FabricatorsActions';
import { getAllStores } from './stores';
import * as pricingPresets from './pricingPresets';
import * as featureInclusion from './featureInclusion';
import * as newStone from './../components/StoneSetup/NewStonePopup/newStonePopupActions';
import { ProjectScopeActionTypes  as projectScope } from './../components/ProjectScope/ProjectScopeActions';
import * as installation from './../components/Installations/InstallationActions';
import * as newInstallationGroup from './../components/Installations/NewInstallationGroup/NewInstallationGroupActions';
import * as newInstallationGroupItem from './../components/Installations/InstallationGroupItems/NewInstallationGroupItem/NewInstallationGroupItemActions';
import * as newFeature from './../components/FeatureCreator/NewFeature/NewFeatureActions';
export { pricingPresets, featureInclusion, newStone, projectScope, installation, newInstallationGroup, newInstallationGroupItem, newFeature }
export {
  getCustomerInfo, updateCustomerInfo, clearInitialValues, setHeaderText,
  showSavingProgress, _authGoogleCalendar, showSuccessPopup,
  handleFooterCancel, handleFooterSave, handleSetLogoFile, getSubscriptions, showESignatureOverlay,
  setSubscriptionId, loadPaymentGateways, savePaymentGateways, showFingerSignatureSetupOverlay
} from './../components/AddNewEntity/AddNewEntityActions';

export const basicAction = (type, payload) => {
  return function(dispatch) {
    return dispatch({
      type: type,
      payload: payload
    });
  }
}

export function requestState(callback) {
  return function(dispatch, getState) {
    let state = getState();
    callback(state);
  }
}

const assignEntityMethods = getApiConfig('Users/AssignEntity');

export function assignEntity(entityId, attachTo, searchKeyword, popupType) {
  const callback = popupType === 'fabricators' ? getAllFabricators : getAllStores;
  return dispatch => {
    const data = {
      entityId,
      attachTo: [attachTo]
    };
    assignEntityMethods.post(data)
      .then(() => { dispatch(callback(searchKeyword, entityId)) })
  }
}

